(function () {
  function setPurchaseMode() {
    var mode = document.querySelector('[data-rre-purchase-mode]');
    if (!mode) return;
    document.documentElement.classList.toggle(
      'rre-mode-quote',
      mode.getAttribute('data-rre-purchase-mode') === 'quote'
    );
  }

  function prefillQuoteForm() {
    var form = document.querySelector('.rre-form-section--quote .rre-form');
    if (!form) return;
    var params = new URLSearchParams(window.location.search);
    var product = params.get('product');
    var variant = params.get('variant');
    var productField = form.querySelector('[data-rre-quote-product]');
    var variantField = form.querySelector('[data-rre-quote-variant]');
    if (product && productField && !productField.value) productField.value = product;
    if (variant && variantField && !variantField.value) variantField.value = variant;
  }

  function syncQuoteLink() {
    var links = document.querySelectorAll('[data-rre-quote-link]');
    var variantField = document.querySelector('.m-product-form--main input[name="id"]');
    if (!links.length || !variantField || !variantField.value) return;
    links.forEach(function (link) {
      var destination = new URL(link.href, window.location.origin);
      destination.searchParams.set('variant', variantField.value);
      link.href = destination.toString();
    });
  }

  function closeSiblingDisclosures(event) {
    var current = event.target.closest('details');
    if (!current || !current.open) return;
    document.querySelectorAll('.rre-header details[open]').forEach(function (detail) {
      if (detail !== current) detail.removeAttribute('open');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setPurchaseMode();
    prefillQuoteForm();
    syncQuoteLink();
    document.querySelectorAll('.rre-header details').forEach(function (detail) {
      detail.addEventListener('toggle', closeSiblingDisclosures);
    });
  });

  document.addEventListener('shopify:section:load', function () {
    setPurchaseMode();
    prefillQuoteForm();
    syncQuoteLink();
  });

  document.addEventListener('change', function () {
    window.requestAnimationFrame(syncQuoteLink);
  });
  document.addEventListener('variant:change', syncQuoteLink);
})();
